import { render, staticRenderFns } from "./Lagenhetsbyte.vue?vue&type=template&id=b0e938c0&"
import script from "./Lagenhetsbyte.vue?vue&type=script&lang=js&"
export * from "./Lagenhetsbyte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports